import { useBrand } from '@contexts/index'
import { upperCaseFirst } from 'upper-case-first'

const UnsubscribeTerms = () => {
  const brand = useBrand()

  return (
    <div className="mt-8">
      <p className="mt-8 mb-4">
        Please note this does not unsubscribe you from any{' '}
        {upperCaseFirst(brand)} dealership databases as they operate as
        independent legal entities. Please contact any {upperCaseFirst(brand)}{' '}
        {brand === 'lexus' ? 'Centre' : 'dealerships'} you may have contacted
        previously to unsubscribe directly.
      </p>
    </div>
  )
}

export default UnsubscribeTerms
